export default __webpack_public_path__ + "static/media/assist_web-md@1x.00e1ce34.webp";